export default __webpack_public_path__ + "static/media/benefit.df8393e1.svg";